import { useState } from "react";
import useMe from "../hooks/useMe.js";

export default function Profile(){
  const { me, loading, refresh } = useMe();
  const API = import.meta.env.VITE_API_BASE_URL;
  const [email, setEmail] = useState("admin@sterling.local");
  const [password, setPassword] = useState("admin123");
  const [msg, setMsg] = useState("");

  const onLogin = async (e)=>{
    e.preventDefault();
    setMsg("Signing in…");
    try{
      const res = await fetch(`${API}/v1/auth/login`,{
        method:"POST", credentials:"include",
        headers:{ "Content-Type":"application/json" },
        body: JSON.stringify({ email, password, turnstileToken:"bypass" })
      });
      if(!res.ok){ const j = await res.json().catch(()=>({})); setMsg(`Login failed: ${j.error || res.status}`); return; }
      await refresh(); setMsg("Logged in.");
    }catch{ setMsg("Network error."); }
  };

  const onLogout = async ()=>{
    try{ await fetch(`${API}/v1/auth/logout`, { method:"POST", credentials:"include" }); }catch{}
    await refresh();
  };

  if (loading) return <div style={{padding:16}}><h1>Profile</h1><p>Loading…</p></div>;

  if (me && me.email) {
    return (
      <div style={{ padding:16 }}>
        <h1>Profile</h1>
        <p><strong>Email:</strong> {me.email}</p>
        <p><strong>Role:</strong> {me.role}{me.is_dev ? " (DEV)" : ""}</p>
        <div style={{ display:"flex", gap:8 }}>
          <button onClick={onLogout}>Log out</button>
          <button onClick={refresh}>Refresh</button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ padding:16, maxWidth:420 }}>
      <h1>Login</h1>
      <form onSubmit={onLogin}>
        <label>Email<br/><input value={email} onChange={e=>setEmail(e.target.value)} autoComplete="username" /></label>
        <br/><br/>
        <label>Password<br/><input type="password" value={password} onChange={e=>setPassword(e.target.value)} autoComplete="current-password" /></label>
        <br/><br/>
        <button type="submit">Sign in</button>
      </form>
      <p style={{ marginTop:12, fontSize:12, opacity:.8 }}>Status: {msg}</p>
    </div>
  );
}

